export const SESSION_PROLONGATION_MODAL_TEST_ID = {
    MODAL: 'modal-sso-session-ending',
    CONTINUE_BTN: 'modal-sso-continue-btn',
    LOG_OUT_BTN: 'modal-sso-logout-btn',
};
